<template>
    <div>
         <div class="actions">
            <router-link to="/view-campaigns" style="font-size:14px;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p> 
                <p>Go Back To Pre-Orders Campaign</p>
                
            </router-link >
            <!-- <a-button @click="showAddProductModal" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                 Add Multiple Products
            </a-button> -->
        </div>
        <div style="display:flex;justify-content: center;">
            <img class="img_size" src="../../assets/img/inventory_1.png"/>
        </div>
       <div style="text-align:center;padding-top:20.7px;">
           <h3>Add Multiple New Product</h3>
       </div>

       <div style="margin-bottom:30px;">
           <div style="display:flex;justify-content: flex-end;margin-bottom:10px;">
                <a-button @click="showProductModal" style="width:159px; height:33px; border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                    Add Product
                </a-button>
            </div>
           <div>
            <a-table
            :columns="columns"
            :data-source="products"
            :loading="tableLoading"
            :pagination="false"
            class="orderTable"
            >

                <!-- <template slot="thumb" slot-scope="">
                    <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
                </template> -->
                <span slot="action" slot-scope="data">
                    
                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                        <a @click="removeProduct(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="delete" theme="filled" /> </a>
                       
                </span>
                <template slot="status" slot-scope='data'>
                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Pending'">
                        <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                        <p style="font-size:12px;color:#ffb102;"> Pending </p>
                    </div>
                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Active'">
                        <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                        <p style="font-size:12px;color:rgb(23 140 20);"> Active </p>
                    </div>
                   

                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="data === `Expired`">
                        <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                        <p style="font-size:12px;color:#41c4fd;"> Expired </p>
                    </div>

                    

                </template>

            </a-table>
            <div style="display:flex;justify-content: center;">
                <a-button @click="addProductToCampaignList" :loading="btnLoading" style="height:33px; border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                    Add Product(s) to Campaign List
                </a-button>
            </div>
        </div>
       </div>
          <a-modal
            class="modalStyle"
            :visible="addProductVisible"
            :footer="null"
            @cancel="handleAddProductCancel"
            >
            <div style="display:flex;justify-content: center;">
                <img class="img_size" src="../../assets/img/inventory_1.png"/>
            </div>
            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Add New Product</p>
            <div>
                <a-form-model
                    ref="addProductForm"
                    :model="newProductForm"
                    :rules="rules"
                >
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Select Product" ref="productId" prop="productId">
                            <a-select
                                show-search
                                placeholder="Choose your product"
                                option-filter-prop="children"
                                v-model="newProductForm.productId"
                                :filter-option="filterOption"
                            >
                                <a-select-option v-for="product in availableProducts" :key="product.id" v-bind:value="product.id">
                                    {{product.brandName}}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Margin %" ref="margin" prop="margin">
                            <a-input
                                class=""
                                v-model="newProductForm.margin"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Max Quantity" ref="maxQuantity" prop="maxQuantity">
                            <a-input
                                class=""
                                v-model="newProductForm.maxQuantity"
                            />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-model-item label="Discount" ref="discount" prop="discount">
                            <a-input
                                class=""
                                v-model="newProductForm.discount"
                            />
                        </a-form-model-item>
                    </a-col>

                </a-row>
                <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
                </div>

                <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                    <a-button @click="addProductToList" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                        Add Product
                    </a-button>
                </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import _ from 'lodash';

const columns = [
  {
    title: 'ID',
    // width: 150,
    // key: 'id',
    dataIndex: 'id',
  },
  {
    title: 'Product Name',
    dataIndex: 'productName',
    // key: 'productName',
    // width: 150,
  },

  {
    title: "Max Q'ty",
    dataIndex: 'maxQuantity',
    // key: 'maxQuantity',
    // width: 200,
  },
  {
    title: 'Margin %',
    dataIndex: 'margin',
    //  key: 'margin',
    //  width: 150,
  },
  {
    title: 'Actions',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
];

    export default {
        name: 'AddPreProduct',
        data() {
            return {
                products: [],
                availableProducts:[],
                tableLoading: false,
                loading:false,
                addProductVisible: false,
                btnLoading: false,
                columns,
                pagination: {
                    pageSize:10
                },
                params:{
                    page: 1,
                    perPage:10,
                    searchBy: {},
                    sortBy: {}
                },
                newProductForm:{
                    productId: "",
                    maxQuantity:"",
                    margin:"",
                    discount:""
                },
                rules: {
                    maxQuantity: [
                        { required: true, message: 'Please enter quantity', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^[0-9]*$/), 
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                    productId:[
                        { required: true, message: 'Please select product', trigger: 'change' },
                    ],
                  
                    margin: [
                        { required: true, message: 'Please enter margin', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                    
                    discount: [
                        { required: true, message: 'Please enter discount', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                },
            };
        },
        computed:{
             ...mapGetters(['getOrder']),
        },
        methods:{
            ...mapActions(['addPreOrderProduct','getClientProducts']),
             filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            addProductToList(){
                this.$refs.addProductForm.validate(valid => {
                    if (valid) {

                        let productExists = this.availableProducts.some(product => {
                            return product.id === this.newProductForm.productId
                        });
                        console.log("productExists | ", productExists)
                        console.log("newProductForm | ", this.newProductForm)
                        if (!productExists) {
                            let productName = this.availableProducts.filter(product => product.id === this.newProductForm.productId);
                            let addProduct = {
                                key: this.newProductForm.productId,
                                id: this.newProductForm.productId,
                                productName: productName[0].brandName,
                                maxQuantity: this.newProductForm.maxQuantity,
                                margin: this.newProductForm.margin,
                                discount: this.newProductForm.discount,
                                action: {
                                    id: this.newProductForm.productId,
                                    productName: productName[0].brandName,
                                    maxQuantity: this.newProductForm.maxQuantity,
                                    margin: this.newProductForm.margin,
                                    discount: this.newProductForm.discount
                                }
                            }
                            this.products.push(addProduct)
                            this.addProductVisible = false;
                            this.$refs.addProductForm.resetFields();
                        }
                        
                    }else{
                        return false;
                    }
                })
            },
            removeProduct(data){
                this.products = this.products.filter(product => product.id !== data.id)
            },
            addProductToCampaignList(){
                if(this.products.length > 0){
                    this.btnLoading = true; 
                    this.products.forEach(product => {
                        let request_data = {
                            productId : product.id,
                            margin: product.margin,
                            maxQuantity: product.maxQuantity,
                            discount: product.discount
                        }
                        this.addPreOrderProduct(this.getOrder.id,request_data)

                    })
                    this.btnLoading = false;
                    this.$router.push('/view-campaigns').catch(()=>{});
                    this.showSuccessAlert("New Product(s) Added Successfully")
                }
            },
            showProductModal(){
                this.addProductVisible = true;
            },
            handleAddProductCancel(){
                this.addProductVisible = false;
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
        },
       
        created(){
           this.getClientProducts(this.params).then(response => {
            //    
               if(response.status === 200){
                   this.availableProducts = response.data.data;
               }else{
                   console.log('Error | ', response)
               }
           },error =>{
               console.log('Error | ', error)
           })
        }
    }
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.actions{
    display: flex;
    justify-content: space-between;
}
.img_size{
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText{
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}
.descInputText{
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}
.dropdownItem{
    width: 336px;
    border-radius: 5px;
}

.selecInput{
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}


/* .dropdownItem >>> .ant-select-selection__placeholder, 
.ant-select-search__field__placeholder {
    line-height: 29px;
}
.dropdownItem >>> .ant-select-selection--single {
    position: relative;
    height: 45px;
    cursor: pointer;
}
.dropdownItem >>> .ant-select-selection-selected-value {
    line-height: 46px;
} */
.spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}
</style>

